import { Component, OnInit, ElementRef, ViewChild, Inject } from '@angular/core';

import { BaseComponent } from '../../base/base.component';
import { WizardService } from '../../../services/wizard/wizard.service';
import { ClipboardService } from 'common-lib/services';

import { IWizardMeetingCreateStatus } from '../../../models/wizard-response.model';

declare var $: any;
@Component({
    selector: 'wizard-completion',
    templateUrl: './completion.component.html',
    styleUrls: ['./completion.component.scss', '../../form-styles.scss']
})
export class CompletionComponent extends BaseComponent implements OnInit {
    @ViewChild('inviteLink') inviteLink: ElementRef;
    public isInternal = false;
    public isPlugin = false;
    public meetingCreateStatus: IWizardMeetingCreateStatus = 'scheduled';

    constructor(
        public wizardService: WizardService,
        @Inject(ClipboardService) private clipBoardService: ClipboardService
    ) {
        super();
    }

    ngOnInit() {
        this.meetingCreateStatus = this.wizardService.responseData.meetingCreateStatus;
        this.isPlugin = this.wizardService.config.isPlugin;
    }

    ngAfterViewInit() {
        if (this.inviteLink && this.meetingCreateStatus === 'link-generated') {
            $(this.inviteLink.nativeElement).popup({
                content: 'Click to copy link',
                hoverable: true
            });
        }
    }

    handleCopyLink(link: string) {
        this.clipBoardService.copyText(link);
    }
}
